import {getAssetUrl} from '@Utils/s3.util';
import {LayeringType} from '@Libraries/layering-type';
import type {LayersVisualConfig} from '@Modals/ai-action-loading-modal/ai-action-loading-modal.types';
import type {LayersAnimationTiming} from '@Components/editable-text-layers-visual/editable-text-layers-visual.types';
import {LayerRole} from '@Components/editable-text-layers-visual/editable-text-layers-visual.types';

export const MAKE_TEXT_EDITABLE_LAYER_URLS: Record<LayerRole, string> = {
  [LayerRole.BACKGROUND]: getAssetUrl('ai-chat-editable-text-layers-music-fest-bg.webp'),
  [LayerRole.TEXT]: getAssetUrl('ai-chat-editable-text-layers-music-fest-text.webp'),
};

export const MAKE_TEXT_EDITABLE_LAYERS_TIMING: LayersAnimationTiming = {
  toSeparated: {delayMs: 0, durationS: 2},
  toComposed: {delayMs: 0, durationS: 2},
};

export const getMakeTextEditableLoadingTexts = (): string[] => {
  return [window.i18next.t('pmwjs_mte_preparing_design'), window.i18next.t('pmwjs_mte_layers_slight_changes')];
};

export const getMakeTextEditableLoadingTitle = (layeringType: LayeringType = LayeringType.TEXT): string => {
  if (layeringType === LayeringType.WITH_LAYERS) {
    return window.i18next.t('pmwjs_extracting_image_layers');
  }
  return window.i18next.t('pmwjs_extracting_text_layers');
};

export const getMakeTextEditableLayersVisualConfig = (layeringType: LayeringType = LayeringType.TEXT): LayersVisualConfig => {
  return {
    loadingTitle: getMakeTextEditableLoadingTitle(layeringType),
    readyTitle: window.i18next.t('pmwjs_mte_edit_design'),
    imageUrls: MAKE_TEXT_EDITABLE_LAYER_URLS,
    timing: MAKE_TEXT_EDITABLE_LAYERS_TIMING,
  };
};
